// Comunicación con la página que embebe este widget en un <iframe> (p.ej. una página WordPress
// por idioma: bikerentmallorca.com/en/book -> <iframe src="https://book.bikerentmallorca.com/en">).
// El widget no conoce el dominio padre, así que se usa postMessage con targetOrigin '*';
// los datos enviados (altura, petición de scroll) no son sensibles.

const MESSAGE_SOURCE = 'bike-rental-booking-widget';

export const isEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch {
    // Acceso a window.top bloqueado por políticas cross-origin => está embebido.
    return true;
  }
};

const postToParent = (payload) => {
  if (!isEmbedded()) return;
  window.parent.postMessage({ source: MESSAGE_SOURCE, ...payload }, '*');
};

export const sendResizeMessage = (height) => {
  postToParent({ type: 'resize', height });
};

export const sendScrollToTopMessage = () => {
  postToParent({ type: 'scrollToTop' });
};
